<template>
    <d-card class="h-100">
        <d-card-header :class="{ 'border-bottom success': bingAds }" class="border-bottom">Microsoft Advertising</d-card-header>
        <d-card-body>
            <d-col class="d-flex justify-content-center">
                <img class="img-fluid" src="@/assets/images/microsoft-logo.png" alt="microsoft">
            </d-col>
        </d-card-body>
        <d-card-footer class="d-flex justify-content-center">
            <d-button v-if="bingAds" @click="connectBingAds" class="btn btn-secondary">Connected</d-button>
            <d-button v-else @click="connectBingAds" class="btn btn-success">Connect</d-button>
        </d-card-footer>
    </d-card>
</template>

<script>
    import { BaService } from '@/main';
    import notification from '@/mixins/notification';

    export default {
        mixins: [notification],

        props: {
            bingAds: null
        },

        methods: {
            async connectBingAds() {
                try {
                    const bingAdsUrl = await BaService.connect(this.$route.params.id)
                    $cookies.set('website_id', this.$route.params.id);
                    window.location.replace(bingAdsUrl)
                } catch(e) {
                    this.showNotification('warn', 'We have a problem', 'Oops! cant connect Microsoft Advertising')
                    console.log(e)
                }
            }
        },
    };
</script>
